/**
 * Mixin for handling registration and un-registration of event handlers.
 */
import { each } from 'lodash';

const EventHandlerMixin = {

  /**
   * Registers events with the generated leafletComponent if namespaced
   * events are passed, such as onLeafletClick or onLeafletZoomEnd.
   * @param leafletComponent A leaflet component to listen to
   * @param properties The properties of the wrapping react component
   */
  registerEventHandlers: function (leafletComponent, properties) {
    var eventMatcher = /^onLeaflet([A-Z].+)/;

    each(properties, function (handler, property) {
      if (eventMatcher.test(property) && handler) {

        // Grab all onLeafletEventName properties and lowercase them
        // to match leaflet events. Remove onLeaflet and just
        // keep eventname
        const leafletEvent = property.toLowerCase().substring(9);

        // Register an event callback handler
        leafletComponent.on(leafletEvent, handler);
      }
    });
  },

  /**
   * Removes all listeners on this leaflet component
   *
   * @param leafletComponent The leaflet component to unregister event for
   */
  unRegisterEventHandlers: function (leafletComponent) {
    if (leafletComponent.clearAllEventListeners) {
      leafletComponent.clearAllEventListeners();
    }
  }

};

export default EventHandlerMixin;